var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 32,
    viewBox: "0 0 8 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41603 0.72265C2.26285 0.492886 1.95241 0.430799 1.72265 0.583975C1.49289 0.737151 1.4308 1.04759 1.58397 1.27735L2.41603 0.72265ZM1.50971 31.0981C1.56387 31.3688 1.82728 31.5444 2.09806 31.4903L6.51067 30.6078C6.78145 30.5536 6.95706 30.2902 6.9029 30.0194C6.84875 29.7486 6.58534 29.573 6.31456 29.6272L2.39223 30.4117L1.60777 26.4893C1.55361 26.2185 1.2902 26.0429 1.01942 26.0971C0.748639 26.1513 0.573032 26.4147 0.627187 26.6854L1.50971 31.0981ZM1.58397 1.27735L2.70878 2.96455L3.54083 2.40985L2.41603 0.72265L1.58397 1.27735ZM2.70878 29.0355L1.58398 30.7227L2.41603 31.2773L3.54083 29.5901L2.70878 29.0355ZM2.70878 2.96455C7.9712 10.8582 7.9712 21.1418 2.70878 29.0355L3.54083 29.5901C9.02718 21.3606 9.02718 10.6394 3.54083 2.40985L2.70878 2.96455Z",
    fill: "#8B997F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow-2.2b86ab3d901cd4f17f245bf591f827d7.svg";
export { ForwardRef as ReactComponent };